var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 96 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bd59c6ef-61fd-4283-b83c-ec1590a9f70a",
    "data-name": "Custom System Icons"
  }, /*#__PURE__*/React.createElement("g", {
    id: "f0c23fe7-6ae9-425e-9abe-9171943722bf",
    "data-name": "Add"
  }, /*#__PURE__*/React.createElement("path", {
    className: "acbf4915-1e96-4c46-9135-b8c1f349eb09",
    d: "M28,44H68a4,4,0,0,1,4,4v0a4,4,0,0,1-4,4H28a4,4,0,0,1-4-4v0a4,4,0,0,1,4-4Z",
    transform: "translate(-19.88225 48) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "acbf4915-1e96-4c46-9135-b8c1f349eb09",
    d: "M28,44H68a4,4,0,0,1,4,4v0a4,4,0,0,1-4,4H28a4,4,0,0,1-4-4v0a4,4,0,0,1,4-4Z",
    transform: "translate(48 115.88225) rotate(-135)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/Close.267c029c34f41d7bb81b0ae91ae00313.svg";
export { ForwardRef as ReactComponent };